import React from 'react';
import styled from 'styled-components';

const NavCount = styled.div`
  .question-attempted-meter {
    height: 100%;
    border-top: 0;
    border-bottom: 0;

    .meter {
      height: 12px;
      width: 100%;
      border-radius: 10px;
      background: #1a1c4f;
      overflow: hidden;

      .progress {
        z-index: 30;
        border-radius: 10px;
        height: 12px;
        -webkit-transition: width 0.5s ease-in-out;
        -moz-transition: width 0.5s ease-in-out;
        -o-transition: width 0.5s ease-in-out;
        transition: width 0.5s ease-in-out;

        &--left-align {
          float: left;
        }

        &-success {
          background: #2ecc71;
        }

        &--right-align {
          float: right;
        }

        &-danger {
          background: #ff5d50;
        }
      }
    }

    .description {
      font-size: 13px;
      text-align: center;
      padding: 6px 2px;
      color: white;
    }

    @media (max-width: 375px) {
      width: 120px;
    }
  }
`;

export default function NavProblemCount({ total, attempted }) {
  const totalNum =
    typeof total === 'string' ? Number.parseInt(total, 10) : total;
  const attemptedNum =
    typeof attempted === 'string' ? Number.parseInt(attempted, 10) : attempted;

  const safeTotal =
    typeof totalNum === 'number' && Number.isFinite(totalNum) && totalNum > 0
      ? totalNum
      : 0;
  const count =
    typeof attemptedNum === 'number' &&
    Number.isFinite(attemptedNum) &&
    attemptedNum > 0
      ? attemptedNum
      : 0;

  const rawWidth = safeTotal > 0 ? Math.floor((count * 100) / safeTotal) : 0;
  const width = Math.max(0, Math.min(100, rawWidth));
  return (
    <NavCount
      className="ml-md-3 ml-lg-5 pt-1 pt-md-2"
      id="do-test-problem-counter"
    >
      <div className="question-attempted-meter">
        <div className="meter">
          <div
            className="progress progress-success progress--left-align "
            style={{ width: width ? `${width}%` : '0px' }}
          />
        </div>
        <div className="description">
          {count}/{safeTotal} Question{safeTotal > 1 ? 's' : ''} attempted
        </div>
      </div>
    </NavCount>
  );
}
